import { FaDatabase, FaHtml5, FaNodeJs, FaReact } from "react-icons/fa";
import "./two.css";

const Two = () => {
  return (
    <section id="two" className="my-5 py-5 sectionTwoAnimation">
      <div className="container">
        <div className="row text-center">
          {/* FRONTEND */}
          <div className="col-lg-3 col-sm-6 mb-4">
            <div className="equals d-flex align-items-center flex-column">
              <FaHtml5 size={80} color="#f16529" className="mb-3" />
              <h2 className="mb-3">Frontend Development</h2>
              <p
                className="mb-3"
                style={{
                  fontSize: 18,
                  fontWeight: 400,
                  lineHeight: "1.67",
                  color: "#b0aac0",
                }}
              >
                Learn to create stunning, responsive, and user-friendly web
                interfaces using HTML, CSS, JavaScript, and React.
              </p>
            </div>
          </div>

          {/* BACKEND */}
          <div className="col-lg-3 col-sm-6 mb-4">
            <div className="equals d-flex align-items-center flex-column">
              <FaNodeJs size={80} color="#68a063" className="mb-3" />
              <h2 className="mb-3">Backend Development</h2>
              <p
                className="mb-3"
                style={{
                  fontSize: 18,
                  fontWeight: 400,
                  lineHeight: "1.67",
                  color: "#b0aac0",
                }}
              >
                Build powerful and scalable server-side applications using Node.js,
                Express, and RESTful APIs.
              </p>
            </div>
          </div>

          {/* DATABASE */}
          <div className="col-lg-3 col-sm-6 mb-4">
            <div className="equals d-flex align-items-center flex-column">
              <FaDatabase size={80} color="#00758f" className="mb-3" />
              <h2 className="mb-3">Database Management</h2>
              <p
                className="mb-3"
                style={{
                  fontSize: 18,
                  fontWeight: 400,
                  lineHeight: "1.67",
                  color: "#b0aac0",
                }}
              >
                Master working with both SQL and NoSQL databases like MongoDB and
                MySQL to store and manage data efficiently.
              </p>
            </div>
          </div>

          {/* FULL STACK */}
          <div className="col-lg-3 col-sm-6 mb-4">
            <div className="equals d-flex align-items-center flex-column">
              <FaReact size={80} color="#61dbfb" className="mb-3" />
              <h2 className="mb-3">Full Stack Integration</h2>
              <p
                className="mb-3"
                style={{
                  fontSize: 18,
                  fontWeight: 400,
                  lineHeight: "1.67",
                  color: "#b0aac0",
                }}
              >
                Combine your frontend and backend knowledge to build complete,
                dynamic, and data-driven web applications.
              </p>
            </div>
          </div>
        </div>

        <div className="overFlow text-center">
          <h1 className="text-uppercase">Sami </h1>
          <p className="text-secondary fw-light">
            Full Stack Web Development Instructor
          </p>
        </div>
      </div>
    </section>
  );
};

export default Two;
